import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DESC_ENTITY } from '@constants/desc-entity';
import { IsfHelper } from '@helpers/isf.helper';
import { ShipmentModel, ShortModel } from '@data-layer/models/common';
import { IsfModel } from '@data-layer/models/isf';
import { enumIsfShipmentCode } from '@data-layer/enums/isf';

@Component({
  selector: 'isf-shipment-details',
  templateUrl: './isf-shipment-details.component.html',
  styleUrls: ['./isf-shipment-details.component.scss'],
})
export class IsfShipmentDetailsComponent implements OnInit, OnChanges {
  @Output() public entityCodeEdit: EventEmitter<any> = new EventEmitter<any>();
  @Input() public canEdit = true;
  @Input() public isf: IsfModel;
  @Input() public connectedEntrySummary: ShortModel[];

  public shipment: ShipmentModel;
  public info = DESC_ENTITY.SHIP;
  public isShowMoreEntries = true;
  public enumIsfShipmentCode: typeof enumIsfShipmentCode = enumIsfShipmentCode;

  constructor(private translate: TranslateService) {}

  public ngOnInit(): void {
    this.shipment = IsfHelper.getFullShipment(this.isf);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isf) {
      const { firstChange, previousValue, currentValue } = changes.isf;
      if (!firstChange && previousValue !== currentValue) {
        this.shipment = currentValue.shipment;
      }
    }
  }

  public getValidationText(fieldName: string): string {
    if (!this.shipment.validationMessages || !this.shipment.validationMessages.hasOwnProperty(fieldName)) {
      return '';
    }
    const { value, messages } = this.shipment.validationMessages[fieldName];
    return messages && messages.length ? 'BACK_ERROR.' + messages[0] : value;
  }

  public gotoEdit() {
    this.entityCodeEdit.emit();
  }

  public get isValidShipment(): boolean {
    if (this.shipment.code === enumIsfShipmentCode.HOUSE) {
      return !!this.shipment.houseBill.carrier && !!this.shipment.houseBill.number;
    } else {
      return !!this.shipment.masterBill.carrier && !!this.shipment.masterBill.number;
    }
  }
}
